import { localize } from 'vee-validate'

import store from '@/store'

localize(store.getters['app/locale'])
